import React from 'react';
import { useHistory } from 'react-router-dom';
import { FaUser, FaFileAlt } from 'react-icons/fa';
import { formatActivityDate } from '../utils/dashboardData';
import styles from '../Dashboard.module.scss';

export default function NewsTile({ activity = [] }) {
  const history = useHistory();

  function handleClick(item) {
    if (item.studyId) {
      history.push(`/edit-study/${item.studyId}`);
    }
  }

  return (
    <div className={`${styles.tile} ${styles.newsTile}`}>
      <h3 className={styles.tileTitle}>Dernières actualités</h3>
      <div className={styles.newsList}>
        {activity.length === 0 && <p className={styles.emptyState}>Aucune actualité récente</p>}
        {activity.map((item, index) => (
          <button
            key={`${item.type}-${item.studyId}-${index}`}
            type="button"
            className={styles.newsItem}
            onClick={() => handleClick(item)}
          >
            <span className={styles.newsIcon}>
              {item.type === 'patient' ? <FaUser size={14} color="#5B44EB" /> : <FaFileAlt size={14} color="#5B44EB" />}
            </span>
            <span className={styles.newsContent}>
              <span className={styles.newsLabel}>
                {item.type === 'patient'
                  ? `${item.studyName} - Id ${item.patientId}`
                  : item.documentTitle}
              </span>
              <span className={styles.newsDate}>{formatActivityDate(item.date)}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
